import React from "react";
import { type RouteComponentProps, withRouter } from "react-router-dom";

import { store } from "./app-store";
import { selectUser } from "./slices/user";

export function requireOfferSign<T>(Component: React.ComponentType<T>) {
  class SignOfferComponent extends React.Component<T & RouteComponentProps> {
    componentDidMount() {
      this.checkIfSigned();
    }

    componentDidUpdate() {
      this.checkIfSigned();
    }

    checkIfSigned() {
      const state = store.getState();
      const user = selectUser(state);

      if (user.has_signed_offer === false) {
        this.props.history.push("/pages/offer");
      }
    }

    render() {
      const state = store.getState();
      const user = selectUser(state);

      if (user && user.has_signed_offer) {
        return <Component {...this.props} />;
      }

      return null;
    }
  }

  return withRouter(SignOfferComponent);
}
